// React-Screen CPriceInputMode ("Preiseingabemodus") - Strangler Phase 5,
// ERSTER Screen der Klasse B (zustandsbehaftetes Overlay). Runbook:
// tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle priceinputmode.js (aus
// lib/scripts/pos/components/CMP_CPriceInputMode.js).
//
// Zwei Fixtures, weil dieser Screen zwei DOM-Zustaende hat:
//   tests/react-fixtures/CPriceInputMode.html        - wie draw() ihn baut
//     (PRELOAD aus CSessionHandler.addSession, per .CashWindow
//     {visibility:hidden} unsichtbar; steht in JEDER eingeloggten Baseline)
//   tests/react-fixtures/CPriceInputMode-shown.html  - nach show()
//     (Galerie-Eintrag 20-overlay-betragseingabe)
//
// PARITAETS-DETAIL (hier zum ersten Mal noetig): Legacy-show() aendert die
// Texte per reValue(), und reValue() schreibt NUR innerHTML. Das
// class-Attribut behaelt deshalb den BAUZEIT-Wert aus dem XML - der
// Titel-Absatz bleibt fuer immer class="CCaption titletext Mode", obwohl er
// "Preiseingabemodus" anzeigt. Die Caption unten trennt darum classValue
// (eingefroren) von value (Zustand). Wer beides koppelt, erzeugt dom-drift.
//
// Der Screen wird NIE abgebaut: show() setzt die Sichtbarkeit direkt am
// Wurzelelement, doFinish() ueber properties.styles + reStyle() (beides
// Legacy-Code, der auf dem Bridge-Wurzelelement unveraendert funktioniert -
// React rendert nur INNERHALB der Wurzel).
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';

// Legacy-CCaption: der Builder schreibt den Wert beim BAUEN auch in die
// Klasse; ein spaeteres reValue() aendert nur noch innerHTML. classValue
// weglassen = beides identisch (statische Captions).
function Caption({ bridge, path, addclass, classValue, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' +
    (classValue === undefined ? value : classValue);
  return <p {...bridge.el(path, 'CCaption')} className={cls} style={style} dangerouslySetInnerHTML={{ __html: value }} />;
}

// XML-Defaults aus LYT_bonOverlay.xml - sie stehen fuer immer im
// class-Attribut (s. Kopfkommentar) und sind zugleich der Anfangszustand.
const XML_TITLE = 'Mode';
const XML_CONTENT = ' ';

function PriceInputModeScreen({ bridge }) {
  // Legacy: okButton.properties.events.onMousedown = this.ok
  //         ok(component, parameters) -> POS.getComponentById(parameters[0]).doOk("screen")
  // Der Umweg ueber das Parameter-Attribut entfaellt (die Closure kennt die
  // Bridge), das Attribut selbst bleibt fuer die DOM-Paritaet.
  const okButton = bridge.widget('7', 'CPushButton', {
    events: {
      onMousedown: () => {
        log.add(4, 'Info', 'Pressed OK Button', '');
        bridge.doOk('screen');
      },
      onMouseout: true,
      onMouseup: true,
    },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });
  // Legacy: backButton.properties.events.onMousedown = this.finish
  const backButton = bridge.widget('8', 'CPushButton', {
    events: {
      onMousedown: () => {
        log.add(4, 'Info', 'Pressed CANCEL Button', '');
        bridge.doFinish();
      },
      onMouseout: true,
      onMouseup: true,
    },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });

  return (
    <>
      {/* wholeOverlay */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay" style={{ position: 'absolute' }}></div>
      {/* overlay */}
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }}></div>
      {/* titleBack */}
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }}></div>
      {/* titleText - Klasse eingefroren auf den XML-Wert, Text aus dem Zustand */}
      <Caption bridge={bridge} path="3" addclass="titletext" classValue={XML_TITLE} value={bridge.state.title} />
      {/* contentText - dito */}
      <Caption bridge={bridge} path="4" addclass="contenttext" classValue={XML_CONTENT} value={bridge.state.content} />
      {/* priceText */}
      <Caption bridge={bridge} path="5" addclass="pricetext" value=" " />
      {/* unitsText */}
      <Caption bridge={bridge} path="6" addclass="unitstext" value=" " />
      {/* okButton */}
      <div {...okButton} className="CPushButton okbutton">
        <Caption bridge={bridge} path="7:0" addclass="" value=" " />
      </div>
      {/* backButton */}
      <div {...backButton} className="CPushButton backbutton">
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
      </div>
    </>
  );
}

// Die Container, die show()/doFinish() sperren bzw. freigeben - Reihenfolge
// wie im Legacy-Code.
const BLOCKED = ['bonfnc', 'payment', 'payment2', 'bonedit', 'prodSelect', 'leftPad'];

function setMainEnabled(Main, enabled) {
  for (const name of BLOCKED) Main.components[name].setEnabled(enabled);
}

export const CPriceInputMode = defineReactScreen({
  className: 'CPriceInputMode',
  addclass: 'CPriceInputMode CashWindow',
  htmlType: 'div',
  Screen: PriceInputModeScreen,
  initialState: { title: XML_TITLE, content: XML_CONTENT },
  // Legacy-prepare() ohne den XML-/Event-Teil (die Events haengen jetzt in
  // der JSX). Die vier Felder setzte der Legacy-KONSTRUKTOR; hier ist
  // prepare() die frueheste Stelle - CSessionHandler.addSession ruft draw()
  // unmittelbar nach addChild(), lange bevor jemand mode/type/qty setzt.
  prepare(bridge) {
    bridge.mode = null;
    bridge.type = null;
    bridge.qty = null;

    bridge.Main = POS.sessions.getSessionComponent();
  },
  methods: {
    // Aufrufer: CMainPOS.addProdWithPrice ("freeprod", Produktbutton mit
    // FreePrice=1) und CChangesPanel.doNewBunchWithPrice ("bunch").
    // Beide rufen show() OHNE Argumente; die Legacy-Signatur
    // (component, parameters) stammt aus der Zeit als Event-Handler.
    show(bridge) {
      document.getElementById(bridge.id).style.visibility = 'visible';

      setMainEnabled(bridge.Main, false);

      let prodName;
      switch (bridge.mode) {
        case 'bunch':
          prodName = bridge.type;
          break;
        case 'freeprod':
          prodName = bridge.type[1];
          break;
      }

      const text = bridge.t('LABELS', 'PRICE_INPUT_MODE_TEXT1') + ' "' +
        prodName + '" ' + bridge.t('LABELS', 'PRICE_INPUT_MODE_TEXT2');

      bridge.update({ title: bridge.t('LABELS', 'PRICE_INPUT_MODE'), content: text });

      bridge.Main.confirmInput();
    },
    // Aufrufer: OK-Knopf (from "screen"). Der zweite Aufrufer war der
    // Funkscanner (from "funk"); er ist am 26.8.2026 entfallen, sein Zweig
    // damit unerreichbar. Die Abfrage auf "screen" bleibt stehen - sie ist
    // jetzt immer wahr, aber so bleibt sichtbar, woher der Wert kommt.
    doOk(bridge, from) {
      let sum;
      if (from == 'screen')
        sum = bridge.Main.vacuumInfoValue(bridge.Main);

      if (!sum || parseFloat(sum) == 0)
        return;

      switch (bridge.mode) {
        case 'bunch':
          bridge.Main.BonManager.addNewBunch(sum, bridge.type, bridge.qty);
          break;
        case 'freeprod':
          bridge.Main.BonManager.preAddEntryPOS(bridge.type[2], bridge.type[0], sum, true);
          break;
      }



      bridge.doFinish();
    },
    // Aufrufer: Abbrechen-Knopf und doOk.
    doFinish(bridge) {
      setMainEnabled(bridge.Main, true);


      // Legacy laesst die Texte stehen (reValue erst beim naechsten show())
      // - der Zustand bleibt hier deshalb absichtlich unangetastet.
      bridge.properties.styles.visibility = 'hidden';
      bridge.reStyle();
    },
  },
});
